import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ScoreItem } from "./ScoreItem";

interface AssessmentData {
  adaptive_behavior_composite_standard_score?: number;
  communication_score?: number;
  daily_living_score?: number;
  socialization_score?: number;
  motor_score?: number;
}

interface Assessment {
  data: AssessmentData;
}

interface AverageScoreProps {
  dataAssessments: Assessment[];
}

const AverageScore: React.FC<AverageScoreProps> = ({ dataAssessments }) => {
  const theme = useTheme();
  const { t } = useTranslation(["clientHeader"]);
  const [assessment, prevAssessment] = dataAssessments;

  const abs = assessment?.data?.adaptive_behavior_composite_standard_score;
  const cs = assessment?.data?.communication_score;
  const dls = assessment?.data?.daily_living_score;
  const sc = assessment?.data?.socialization_score;
  const ms = assessment?.data?.motor_score;

  const absPrev = prevAssessment?.data?.adaptive_behavior_composite_standard_score;
  const csPrev = prevAssessment?.data?.communication_score;
  const dlsPrev = prevAssessment?.data?.daily_living_score;
  const scPrev = prevAssessment?.data?.socialization_score;
  const msPrev = prevAssessment?.data?.motor_score;

  return (
    <Box component="section" sx={{ mt: theme.spacing(10) }}>
      <Typography variant="subtitle1" sx={{ mb: 3, fontSize: "16px", fontWeight: 600 }}>
        {t("clientHeader:assessments.scoreAverages")}
      </Typography>

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 3 }}>
        <Box sx={{ gridColumn: "1 / -1" }}>
          <ScoreItem
            label={t("clientHeader:assessments.adaptiveBehaviorComposite")}
            currentValue={abs}
            previousValue={absPrev}
          />
        </Box>

        <ScoreItem
          label={t("clientHeader:assessments.communicationScore")}
          currentValue={cs}
          previousValue={csPrev}
        />

        <ScoreItem
          label={t("clientHeader:assessments.dailyLivingScore")}
          currentValue={dls}
          previousValue={dlsPrev}
        />

        <ScoreItem
          label={t("clientHeader:assessments.socializationScore")}
          currentValue={sc}
          previousValue={scPrev}
        />

        <ScoreItem
          label={t("clientHeader:assessments.motorSkills")}
          currentValue={ms}
          previousValue={msPrev}
        />
      </Box>
    </Box>
  );
};

export default AverageScore;
